import { render, staticRenderFns } from "./healthIndex.vue?vue&type=template&id=e1e58904&scoped=true"
import script from "./healthIndex.vue?vue&type=script&lang=js"
export * from "./healthIndex.vue?vue&type=script&lang=js"
import style0 from "./healthIndex.vue?vue&type=style&index=0&id=e1e58904&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e58904",
  null
  
)

export default component.exports